export type Tractor = {
    tractorID: string;
    farmID: string;
    licensePlateNumber: string;
    tractorShortCode: string;
    tractorModel: string;
    tractorOrder: number;
}

export type Sprayer = {
    sprayerID: string;
    farmID: string;
    sprayerName: string;
    sprayerModel: string;
    volumeL: number;
}

export type Driver = {
    userID: string;
    fullName: string;
}

export type Preparer = {
    userID: string;
    fullName: string;
}

export type Block = {
    id: string;
    name: string;
    farmID: string;
    hectares: number;
} 

export type Trap = {
    trapID: string;
    blockID: string;
    trapNumber: number;
    trapTypeCode: number;
    longitude: number;
    latitude: number;
    accuracy: number;
    installedDate: string;
}

export type Farm = {
    farmID: string;
    farmName: string;
    imageURL: string;
    hectares: number;
    customerCompanyName?: string;
    isPrimaryFarm?: boolean;
    blocks?: Block[];
    tractors?: Tractor[];
    sprayers?: Sprayer[];
    drivers?: Driver[];
    preparers?: Preparer[];
    traps?: Trap[];
}

export const undefinedFarm = {
    farmID: '',
    farmName: '',
    imageURL: '',
    hectares: 6,
    customerCompanyName: '',
    isPrimaryFarm: false,
    blocks: [],
    tractors: [],
    sprayers: [],
    traps: []
}